document.addEventListener("DOMContentLoaded", function () {

  const basePriceInput = document.getElementById("base-vaiant-price");
  if (!basePriceInput) return;

  // Get variants data
  const variantsData = JSON.parse(
    document.getElementById("ProductVariants")?.textContent || "{}"
  );


  // Function to update base price
  function updateBasePrice(variantId) {
    const variant = variantsData.find(v => v.id == variantId);
    if (!variant) return;

    const incPrice = variant.price; // in cents
    const excPrice = Math.round((variant.price / 1.2));

    basePriceInput.setAttribute("data-inc-base-price", incPrice);
    basePriceInput.setAttribute("data-exc-base-price", excPrice);

    console.log("✅ Base price updated:", {
      inc: incPrice,
      exc: excPrice
    });
  }

  // Dropdown variant selector
  document.addEventListener("change", function (event) {
    if (event.target.name === "id") {
      updateBasePrice(event.target.value);
    }
  });

  // Radio button variant selector
  document.querySelectorAll('input[type="radio"][name="id"]').forEach(radio => {
    radio.addEventListener("change", function () {
      updateBasePrice(this.value);
    });
  });

});